<form [formGroup]="formGroupMarktplatzbedingungen()">
  <div class="matchmaker">
    <a href="https://www.aareon.de/mareon/handwerksbetriebe/matchmaker" target="_blank" title="Informationen zum Marktplatz" style="display: flex; align-items: center; gap: 8px;">
      <img src="/assets/matchmaker.svg" alt="Hallo" width="40" height="40" />
      <span>{{'registrierung.marktplatzbedingungen.mehr_erfahren' | translate}}</span>
    </a>
  </div>
  <br />

  <div class="flex-container">
    @if(isTestUmgebung() && !isMarktPlatzAusgeschlossen()) {
      <div class="info-banner info-banner--success">
        <span>{{'testumgebung'|translate}}</span>
      </div>
    }
  </div>

  <div class="flex-container">
    @if(!isMarktPlatzAusgeschlossen()) {
      <div style="flex: 12; margin: 4px">
        <mat-checkbox formControlName="einverstanden">{{'registrierung.marktplatzbedingungen.ich_will_teilnehmen' | translate}}
        </mat-checkbox>
      </div>
    } @else {
      <div class="info-banner info-banner--warning">
        <span>{{'aareonuser'|translate}}</span>
      </div>
    }
  </div>

  <br />
  @if (!isEinverstanden() && !isMarktPlatzAusgeschlossen()) {
    <div style="padding: 24px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <div class="illustration_background">
        <img ngSrc="/assets/illustration_approval.svg" alt="Marktbedingung akzeptieren" width="177" height="144" priority/>
      </div>
    </div>
  }
  <br />
  @if (isEinverstanden() && !isMarktPlatzAusgeschlossen()) {
    <p>
      {{'registrierung.marktplatzbedingungen.hinweis_gewerke' | translate}}
    </p>

    <h1>{{'registrierung.marktplatzbedingungen.ihre_gewerke' | translate}}</h1>
    <div class="container_select_buttons">
      @for (item of gewerke(); track item) {
        <div class="select_button">
          <button mat-button adclSelectorType="small" [adclSelectorButton]="item.checked" (click)="onGewerkeChange(item)">
            {{item.label}}
          </button>
        </div>
      }
    </div>
    <h1>{{'registrierung.marktplatzbedingungen.taetigkeitsgebiet' | translate}}</h1>
    <p>{{'registrierung.marktplatzbedingungen.umkreis_waehlen' | translate}}</p>
    <div class="container_select_buttons">
      @for (item of umkreise(); track item) {
        <div class="select_button">
          <button mat-button adclSelectorType="small" [adclSelectorButton]="item.checked" (click)="onUmkeisChange(item)">
            {{item.label}}
          </button>
        </div>
      }
    </div>
  }
</form>
